import { BadgeCheck, CircleAlert, Clock3 } from "lucide-react";

const ICON = { Cleared: BadgeCheck, Pending: Clock3, Missing: CircleAlert };

export const ClearanceSummary = ({ summary }) => {
  if (!summary) return null;
  return (
    <div className="clearance-summary" data-testid={`clearance-${summary.assignment_id}`}>
      <dl className="client-assignment-details">
        <div><dt>Role</dt><dd data-testid={`clearance-role-${summary.assignment_id}`}>{summary.role}</dd></div>
        <div><dt>License</dt><dd data-testid={`clearance-license-${summary.assignment_id}`}>{summary.license_status}</dd></div>
      </dl>
      {summary.requirements.length ? (
        <ul className="clearance-list">
          {summary.requirements.map((item) => {
            const Icon = ICON[item.status] || CircleAlert;
            return (
              <li key={item.key} className={`clearance-item is-${item.status.toLowerCase()}`} data-testid={`clearance-item-${summary.assignment_id}-${item.key}`}>
                <Icon size={14} />
                <span>{item.label}</span>
                <strong>{item.status}</strong>
                <small>checked {new Date(item.checked_at).toLocaleDateString()}{item.note ? ` · ${item.note}` : ""}</small>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="pairing-meta" data-testid={`clearance-none-${summary.assignment_id}`}>No compliance requirements are turned on for your organization yet.</p>
      )}
    </div>
  );
};
